<template>
    <div class="mobile-sidebar" :class="{open: isOpenSendwichMobile}" v-if="setup != null">
        <div class="mobile-lang">
            <ul class="lang-link-select">
                <li class="body-lang-ru"><a href="#" @click.prevent="setLocale('')">Рус</a></li>
                <li class="body-lang-kz"><a href="#" @click.prevent="setLocale('kz/')">Каз</a></li>
            </ul>
        </div>
        <div class="nav-main mobile-nav-main navigation-scroll-spy" v-if="setup != 0">
            <ul class="list-unstyled nav">
                <li v-for="(nav,index) in setup.main_page_navigation">
                    <a :href="'#section-' + nav.href" 
                    @click="closeMobileMenu(!isOpenSendwichMobile)"
                    v-scroll-to="{
                        el: '#section-' + nav.href,
                        offset: -54
                    }">
                        {{nav.name}}
                    </a>
                </li>
            </ul>
        </div>
        <div class="mobile-link-to-present">
            <a :href="setup.btn_present_group.file" class="btn-present" target="_blank">
                <svg-icon icon-class="download" className="icon-download"/>
                <strong>{{setup.btn_present_group.title_mobile}}</strong>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'mobileSidebar',
        data () {
            return {
            }
        },
        computed: {
            setup() {
                return this.$store.state.pageSetup
            },
            isOpenSendwichMobile() {
                return this.$store.state.isOpenSendwichMobile
            },
        },
        methods: {
            setLocale(lang) {
                localStorage.setItem('language', lang);
                document.location.reload(true);
            },
            closeMobileMenu(data) {
                this.$store.commit('Open_sendwich_mobile', data);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
            },
            scrollSpyNavigation () {
                console.log('asdasdsdaasd');
                $('html,body').scrollspy({ 
                    target: '.navigation-scroll-spy',
                    offset: 0
                });
            },
            // disableOverlay() {
            //     this.$store.commit('Open_Sendwich', false);
            //     document.getElementsByTagName('body')[0].classList.remove('overlay-open');
            // }
        },
        created() {
        },
        mounted() {
            this.$store.watch(
                (state) => state.pageSetup,
                (newValue) => {
                    if (newValue != null) {
                        // this.scrollSpyNavigation();
                    }
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/nav-main/mobile-sidebar.scss';
    // @import '@/styles/components/nav-main/respond-nav-main.scss';
</style>